export const ACCOUNT_STALE_TIME_MS = 6 * 60 * 60 * 1000; // 6 hours in milliseconds
export const STALE_CHECK_INTERVAL_MS = 60 * 1000; // 1 minute in milliseconds